import { createSlice } from "@reduxjs/toolkit";
import { logout } from "./authSlice";

interface IEmployer {
    name: string,
    description: string,
    employerCode: string,
    emailAddress: string,
    includeInScheduleNotification: boolean,
    users: {
        userId: string,
        emailAddress: string,
        firstName: string,
        lastName: string,
        phoneNumber: string,
        roles: string[]
    }[]
}
interface EmployerState {
  employers: Array<IEmployer> | [];
  employer: null | IEmployer
}

const initialState: EmployerState = {
  employers: [],
  employer: null
}

export const employersSlice = createSlice({
  name: "Employers",
  initialState,
  reducers: {
    addEmployersList:(state, action)=>{
      state.employers = action.payload;
    },
    selectEmployer:(state, action)=>{
      state.employer = action.payload;
    },
    addEmployer:(state, action)=> {},
    removeEmployer:(state, action)=> {},
   updateEmployer:(state, action)=> {},
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state = {...initialState};
      return state;
    });
  }
})

export const {
    addEmployer,
    addEmployersList,
    updateEmployer,
    removeEmployer,
    selectEmployer,
} = employersSlice.actions;

export default employersSlice.reducer;
